import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Media, Row, Tooltip } from 'reactstrap';
import * as _ from 'lodash';

import './skills.scss';

interface SkillsComponentProps {
  technologies: any[];
  methodologies: any[];
  languages: any[];
}

interface SkillsComponentState {
  tooltipsOpen: boolean[];
}

class SkillsComponent extends Component<SkillsComponentProps, SkillsComponentState> {

  constructor(props: any) {
    super(props);

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.renderTechnology = this.renderTechnology.bind(this);

    this.state = {
      tooltipsOpen: props.technologies.map(() => false),
    };
  }

  toggleTooltip(index: number) {
    this.setState((previousState: SkillsComponentState) => {
      const tooltipsOpen: boolean[] = [...previousState.tooltipsOpen];
      tooltipsOpen[index] = !tooltipsOpen[index];
      return {tooltipsOpen};
    });
  }

  render() {
    return (
        <article role="skills" id="skills">
          <h2>Skills</h2>
          <Row>
            <Col md={6}>
              <h3>Technologies</h3>
              {this.props.technologies.map(this.renderTechnology)}
            </Col>
            <Col md={6}>
              <div>
                <h3>Methodologies</h3>
                {this.props.methodologies.map(this.renderMethodology)}
              </div>
              <div>
                <h3>Languages</h3>
                <Row>
                  {this.props.languages.map(this.renderLanguage)}
                </Row>
              </div>
            </Col>
          </Row>
        </article>
    );
  }

  renderTechnology(entry: any, index: number) {
    const id = `tech-${index}`;
    return (
        <div role="technology" key={`tech-${index}`}>
          <i id={id} className={entry.icon}/>
          <Tooltip
              placement="bottom"
              target={id}
              delay={0}
              isOpen={this.state.tooltipsOpen[index]}
              toggle={() => this.toggleTooltip(index)}
          >
            {entry.name}
          </Tooltip>
        </div>
    );
  }

  renderMethodology(entry: any, index: number) {
    return (
        <Media role="methodology" key={`edu-${index}`}>
          <Media left={true}>
            <i className={`fa ${entry.icon}`}/>
          </Media>
          <Media body={true}>
            <h4>{entry.name}</h4>
            <p>{entry.description}</p>
          </Media>
        </Media>
    );
  }

  renderLanguage(language: any, index: number) {
    return (
        <Col xs={6} role="language" key={`lang-${index}`}>
          <h4>{language.name}</h4>
          <p>{language.level}</p>
        </Col>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    technologies: _.get(state.cv, 'skills.technologies', []),
    methodologies: _.get(state.cv, 'skills.methodologies', []),
    languages: _.get(state.cv, 'skills.languages', []),
  };
};

export default connect(mapStateToProps, null)(SkillsComponent);



// WEBPACK FOOTER //
// ./src/components/skills/skills.component.tsx